import { Contact } from "./Contact";
import { DateUtils } from "../utils/DateUtils";
import _ from "lodash";

export class AvisDePrelevement {
    id?: number;
    client_id?: number;
    _client?: Contact;
    fournisseur_name?: string;
    date?: string;
    date_emission?: string;
    reference?: string;
    montant?: number;
    summary?: string;
    files: Array<any> = [];
    created_at?: string;
    updated_at?: string;

    constructor(data: any) {
        _.assign(this, _.omit(data, ["client", "files"]));
        if (data.client) {
            this._client = new Contact(data.client);
        }
        if (data.files) {
            this.files = data.files;
        }
    }

    // Fournisseur getter/setter
    get client(): Contact | undefined {
        return this._client;
    }

    set client(value: Contact | undefined) {
        if (value) {
            this._client = value;
            this.client_id = value.id;
        }
    }

    // Date formatting getters
    get date_str(): string {
        if (this.date) {
            return DateUtils.sqlToDateStr(this.date, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get date_emission_str(): string {
        if (this.date_emission) {
            return DateUtils.sqlToDateStr(this.date_emission, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get creation_date_str(): string {
        if (this.created_at) {
            return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    // Serialize method for API calls
    serialize(): AvisDePrelevement.IAvisDePrelevement {
        return {
            id: this.id,
            client_id: this.client_id,
            fournisseur_name: this.fournisseur_name,
            date: this.date,
            date_emission: this.date_emission,
            reference: this.reference,
            montant: this.montant,
            summary: this.summary,
        };
    }
}

// Interface for serialization
export namespace AvisDePrelevement {
    export interface IAvisDePrelevement {
        id?: number;
        client_id?: number;
        fournisseur_name?: string;
        date?: string;
        date_emission?: string;
        reference?: string;
        montant?: number;
        summary?: string;
    }
}
